// src/services/analyticsApi.js
// 🎓 TICKET GHTVN9 - Servicio API para analytics de cursos

import apiClient from './apiClient';

/**
 * Registrar tiempo invertido en una actividad
 * @param {string} courseId - ID del curso
 * @param {string} activityId - ID de la actividad
 * @param {number} seconds - Segundos invertidos
 * @returns {Promise<Object>} - { courseId, totalTime, activityTime }
 */
export const trackActivityTime = async (courseId, activityId, seconds) => {
  try {
    const response = await apiClient.post(
      `/courses/${courseId}/progress/time`,
      { activityId, seconds }
    );
    console.log(`⏱️ GHTVN9: Tiempo registrado - ${activityId}: ${seconds}s`);
    return response.data;
  } catch (error) {
    console.error('❌ GHTVN9: Error tracking tiempo:', error);
    throw error;
  }
};

/**
 * Obtener analytics del curso para el alumno actual
 * @param {string} courseId - ID del curso
 * @returns {Promise<Object>} - { courseId, totalTime, completedActivities, activityTime }
 */
export const getCourseAnalytics = async (courseId) => {
  try {
    const response = await apiClient.get(`/courses/analytics/${courseId}`);
    console.log(`📊 GHTVN9: Analytics obtenidos para ${courseId}`);
    return response.data;
  } catch (error) {
    console.error('❌ GHTVN9: Error obteniendo analytics:', error);
    throw error;
  }
};

/**
 * [ADMIN] Obtener analytics agregados de un curso
 * @param {string} courseId - ID del curso
 * @returns {Promise<Object>} - { courseId, totalUsers, avgCompletionRate, avgTimeSpent, completionDistribution, topActivities }
 */
export const getAdminCourseAnalytics = async (courseId) => {
  try {
    const response = await apiClient.get(`/admin/courses/analytics/${courseId}`);
    console.log(`📊 GHTVN9 [ADMIN]: Analytics obtenidos para ${courseId}`);
    return response.data;
  } catch (error) {
    console.error('❌ GHTVN9 [ADMIN]: Error obteniendo analytics:', error);
    throw error;
  }
};

/**
 * [ADMIN] Obtener lista de cursos con métricas básicas
 * @returns {Promise<Array>} - [{ courseId, totalUsers, avgCompletedActivities }]
 */
export const getAllCoursesAnalytics = async () => {
  try {
    const response = await apiClient.get('/admin/courses/analytics');
    console.log(`📚 GHTVN9 [ADMIN]: Analytics de todos los cursos obtenidos`);
    return response.data.courses;
  } catch (error) {
    console.error('❌ GHTVN9 [ADMIN]: Error obteniendo analytics globales:', error);
    throw error;
  }
};
